import { render, staticRenderFns } from "./BalanceChart.vue?vue&type=template&id=1852394c&scoped=true&"
import script from "./BalanceChart.vue?vue&type=script&lang=js&"
export * from "./BalanceChart.vue?vue&type=script&lang=js&"
import style0 from "./BalanceChart.vue?vue&type=style&index=0&id=1852394c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1852394c",
  null
  
)

export default component.exports